import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tagasi avalehele

  <span style="color:#85c1dc;">**FI:**</span>
  Etusivulle

  <span style="color:#85c1dc;">**RU:**</span>
  Вернуться домой
*/
/* @__NO_SIDE_EFFECTS__ */
const m292 = msg(
  mf`Tagasi avalehele`,
  mf`Etusivulle`,
  mf`Вернуться домой`,
)

export { m292 as 'site-error.button.index' }